/*eslint-disable*/
import React from 'react';
import { Flex, Link, List, ListItem, Text } from '@chakra-ui/react';

export default function Footer(props) {
	return (
		<Flex
			flexDirection={{
				base: 'column',
				xl: 'row',
			}}
			alignItems={{
				base: 'center',
				xl: 'start',
			}}
			justifyContent="space-between"
			px="30px"
			pb="20px"
		>
			<Text
				fontSize="sm"
				color="white"
				textAlign={{
					base: 'center',
					xl: 'start',
				}}
				mb={{ base: '20px', xl: '0px' }}
			>
				&copy; {1900 + new Date().getYear()}, <Text as="span">app name</Text>
				<Link href="https://www.simmmple.com" target="_blank">
					Link 1
				</Link>
				&
				<Link href="https://www.creative-tim.com" target="_blank">
					Link 2
				</Link>
				for a better web
			</Text>
		</Flex>
	);
}
